export const TRANSLATION_KEYS = {
  ALREADY_HAVE_ACCOUNT: {
    key: 'Landing_Texto_Parrafo_YaTienesCuenta',
    length: 22,
  },
  LOGIN: {
    key: 'Landing_Boton_Texto_IniciaSesion',
    length: 25,
  },
  TITLE_PART_1: {
    key: 'Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte1',
    length: 32,
  },
  TITLE_PART_2: {
    key: 'Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte2',
    length: 32,
  },
  TELMEX_PART_1: {
    key: 'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte1',
    length: 39,
  },
  TELMEX_PART_2: {
    key: 'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte2',
  },
  TELMEX_PART_3: {
    key: 'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte3',
  },
  THIRD_PROVIDER: {
    key: 'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo2',
    length: 38,
  },
  REGISTER_WITH_EMAIL: {
    key: 'Landing_Boton_Texto_RegistrateConCorreo',
    length: 25,
  },
};